export const isEmbeddedPersonalPanel = () =>
  new URLSearchParams(window.location.search).get('open_personal_panel') ===
  'true'
